import { CardProps, EmbedProps, FrameProps, ImageProps, Item, PreviewProps, ShapeProps, StickyNoteProps, TextProps } from "../../typings/miro";

const { board } = miro

export const FunctionsCreateItem: { [key: string]: any; } = {
    card: board.createCard,
    embed: board.createEmbed,
    frame: board.createFrame,
    image: board.createImage,
    preview: board.createPreview,
    shape: board.createShape,
    sticky_note: board.createStickyNote,
    text: board.createText,
};

export type ItemProps = CardProps | EmbedProps | FrameProps | ImageProps | PreviewProps | ShapeProps | StickyNoteProps | TextProps

export async function createItem(itemProps: ItemProps) {
    try {
        if (itemProps.type) {
            const itemType = itemProps.type
            const nativeItemProps = { ...itemProps as any }
            return await FunctionsCreateItem[itemType](nativeItemProps) as Item;
        }
    } catch (error) {
        console.error(error);
        return undefined;
    }
}